import { useEffect } from "react";

function Referenzen() {
  useEffect(() => {
    window.location.href = "/Dienstleistung#referenzen";
  }, []);

  return null;
}

export default Referenzen;
